module.exports = __webpack_public_path__ + "img/borussia-dortmund.294ad04a.png";